<template>
  <!-- Modal -->
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Delete Workflow Group</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div style="margin-left: auto; margin-right: auto;">
            <p style="font-size:15px">Are you sure you wish to delete this workflow group? It could cause problems if it is still being used</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button v-on:click="deleteWorkflowGroup" data-dismiss="modal" type="button" class="btn btn-danger">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String
    },
    deviceid: {
      type: String
    }
  },
  methods: {
    deleteWorkflowGroup:function(){      
      this.$emit('deleteWorkflowGroup')
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// DeleteWorkflowGroup.vue?1a468b41